<template>
<div class="spot-green">
  <div class="tv-animation">
     <img src="~@/assets/img/spot-green-1.png" alt="Frame 1" />
    <img src="~@/assets/img/spot-green-2.png" alt="Frame 2"/>
    <img src="~@/assets/img/spot-green-3.png" alt="Frame 3"/>
    <img src="~@/assets/img/spot-green-4.png" alt="Frame 4"/>
    <img src="~@/assets/img/spot-green-5.png" alt="Frame 5"/>
    <img src="~@/assets/img/spot-green-6.png" alt="Frame 6" />
    <img src="~@/assets/img/spot-green-7.png" alt="Frame 7"/>
    <img src="~@/assets/img/spot-green-8.png" alt="Frame 8"/>
    <img src="~@/assets/img/spot-green-9.png" alt="Frame 9"/>
    <img src="~@/assets/img/spot-green-10.png" alt="Frame 10"/>
    <img src="~@/assets/img/spot-green-11.png" alt="Frame 11" />
    <img src="~@/assets/img/spot-green-12.png" alt="Frame 12"/>
    <img src="~@/assets/img/spot-green-13.png" alt="Frame 13"/>
    <img src="~@/assets/img/spot-green-14.png" alt="Frame 14"/>
    <img src="~@/assets/img/spot-green-15.png" alt="Frame 15"/>
    <img src="~@/assets/img/spot-green-16.png" alt="Frame 16" />
    <img src="~@/assets/img/spot-green-17.png" alt="Frame 17"/>
    <img src="~@/assets/img/spot-green-18.png" alt="Frame 18"/>
    <img src="~@/assets/img/spot-green-19.png" alt="Frame 19"/>
    <img src="~@/assets/img/spot-green-20.png" alt="Frame 20"/>
    <img src="~@/assets/img/spot-green-21.png" alt="Frame 21"/>
    <img src="~@/assets/img/spot-green-22.png" alt="Frame 22"/>
    <img src="~@/assets/img/spot-green-23.png" alt="Frame 23" />
    <img src="~@/assets/img/spot-green-24.png" alt="Frame 24"/>
    <img src="~@/assets/img/spot-green-25.png" alt="Frame 25"/>
    <img src="~@/assets/img/spot-green-26.png" alt="Frame 26"/>
  </div>
  
</div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "spot-green", 

    computed: {
    ...mapState([
      "trackTime"
    ])
  },
};

</script>

<style lang="scss">
@keyframes green-slide {
  0%,
  4% {
    background-image: url("~@/assets/img/spot-green-1.png");
  }
  4%,
  8% {
    background-image: url("~@/assets/img/spot-green-2.png");
  }
  8%,
  12% {
    background-image: url("~@/assets/img/spot-green-3.png");
  }
  12%,
  16% {
    background-image: url("~@/assets/img/spot-green-4.png");
  }
  16%,
  20% {
    background-image: url("~@/assets/img/spot-green-4.png");
  }
  20%,
  24% {
    background-image: url("~@/assets/img/spot-green-5.png");
  }
  24%,
  28% {
    background-image: url("~@/assets/img/spot-green-5.png");
  }
  28%,
  32% {
    background-image: url("~@/assets/img/spot-green-6.png");
  }
  32%,
  36% {
    background-image: url("~@/assets/img/spot-green-7.png");
  }
  36%,
  40% {
    background-image: url("~@/assets/img/spot-green-8.png");
  }
  40%,
  44% {
    background-image: url("~@/assets/img/spot-green-9.png");
  }
  44%,
  48% {
    background-image: url("~@/assets/img/spot-green-10.png");
  }
  48%,
  52% {
    background-image: url("~@/assets/img/spot-green-11.png");
  }
  52%,
  56% {
    background-image: url("~@/assets/img/spot-green-12.png");
  }
  56%,
  60% {
    background-image: url("~@/assets/img/spot-green-13.png");
  }
  60%,
  64% {
    background-image: url("~@/assets/img/spot-green-14.png");
  }
  64%,
  68% {
    background-image: url("~@/assets/img/spot-green-15.png");
  }
  68%,
  72% {
    background-image: url("~@/assets/img/spot-green-16.png");
  }
  72%,
  76% {
    background-image: url("~@/assets/img/spot-green-17.png");
  }
  76%,
  80% {
    background-image: url("~@/assets/img/spot-green-18.png");
  }
  80%,
  84% {
    background-image: url("~@/assets/img/spot-green-19.png");
  }
  84%,
  88% {
    background-image: url("~@/assets/img/spot-green-20.png");
  }
  88%,
  92% {
    background-image: url("~@/assets/img/spot-green-21.png");
  }
  92%,
  96% {
    background-image: url("~@/assets/img/spot-green-22.png");
  }
  96%,
  100% {
    background-image: url("~@/assets/img/spot-green-23.png");
  }
}


.active {
  .tv-green {
    .tv-animation {
        display: block;
        animation: green-slide 22s step-start;
        background-image:  url("~@/assets/img/spot-green-1.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
  }
}

.tv-green {
  .tv-animation {
      position: absolute;
      background-repeat: no-repeat;

      img {
        display: none;
      }
  }
}
</style>